export const BoostedTypes = {
    Both: 0,
    Live: 1,
    Prematch: 2
}